<template>
  <div class="w-full text-2xl dark:text-white mt-2 dark:bg-gray-900 px-2">
    <div class="dark:bg-gray-800 shadow-sm rounded">
      <addModal @refresh="getAll()" />
      <editModal ref="editCalculateroute" @refresh="getAll()" :detail="selectedItem" />
      <div
        class="h-full bg-white dark:text-gray-400 dark:bg-gray-800 rounded justify-between py-2 px-2"
      >
        <div>
          <div class="flex justify-between items-center">
            <asyncBtn
              @click="$modal.show('addCalculateroute-modal')"
              icon="fa fa-plus"
              text="Yeni Hesap"
              class="px-4 py-1 text-base btn"
            />

            <div class="w-3/12 flex">
              <searchInput
                v-model="search"
                @searcing="() => getAll(true)"
                inputClass="w-full text-lg"
              />
            </div>
          </div>
          <div
            :class="{
              'fixed top-0 w-full z-50 left-0 h-full bg-white': isFullScreen,
            }"
          >
            <div
              :class="{
                'shadow table-height-value overflow-y-scroll border-b border-gray-200 bg-gray-200 dark:bg-gray-900 sm:rounded-lg mt-4': !isFullScreen,
                'w-full overflow-y-scroll h-full': isFullScreen,
              }"
            >
              <div class="relative">
                <LyrausTable
                  :searchBar="false"
                  :data="getCalculatorList()"
                  :columns="columns"
                  :alternateRowBg="['white', 'gray-50']"
                  :containerClass="'w-full'"
                  :innerThClass="'py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700'"
                  :innerTrClass="'border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'"
                  :innerTdClass="'py-2 px-3'"
                  :tdClass="'text-sm p-1 whitespace-normal'"
                  :stickyRight="['buttonsColumn']"
                  :buttonsColumn="{ label: 'İşlem' }"
                >
                  <template v-slot:colButtons="{ item, columnKey }">
                    <!-- Action Buttons -->
                    <div class="flex">
                      <div class="flex items-center justify-end space-x-2 mx-1">
                     <button @click="() => editItem(item)">
                        <i class="fas fa-search text-gray-700"></i>
                      </button>
                    </div>
                    <div class="flex items-center justify-end space-x-2 mx-1">
                      <button @click="() => deleteItem(item)">
                        <i class="fas fa-trash text-gray-700"></i>
                      </button>
                    </div>
                    </div>
                  </template>
                </LyrausTable>
              </div>
            </div>
            <div :class="isFullScreen && 'absolute bottom-4 w-full bg-white'">
              <PaginationComponents
                v-if="totalCount > 0"
                :totalRowCount="totalCount"
                :pageCount="pageCount"
                :currentPage="currentPage + 1"
                @changePage="(r) => (currentPage = r - 1)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//global components
import asyncBtn from "@/components/general/asyncBtn.vue";
import tableLoader from "@/components/general/table-loader.vue";
import PaginationComponents from "@/components/general/pagination.vue";
import searchInput from "@/components/general/search-input.vue";
import tableResizeBtn from "@/components/general/table.resize.btn.vue";

//networking
import axios from "axios";
import { calculate } from "@/networking/urlmanager";

//local components
import addModal from "./components/add.modal.vue";
import editModal from "./components/edit.modal.vue";
export default {
  name: "calculatorPage",
  components: {
    asyncBtn,
    tableLoader,
    addModal,
    editModal,
    PaginationComponents,
    searchInput,
    tableResizeBtn,
  },
  data() {
    return {
      isFullScreen: false,
      load: false,
      selectedItem: "",
      search: "",
      List: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      columns:[
        {
          key:"index",
          label:"#",
        },
        {
          key:"name",
          label:"Hesap Adı",
        },
        {
          key:"startAndFinish",
          label:"Başlangıç - Bitiş Noktaları",
        },
        {
          key:"tOneWay",
          label:"Tek Yön Kilometresi",
        },
      ]
    };
  },
  methods: {
    getAll(isSearch = false) {
      if (isSearch) this.currentPage = 0;
      this.load = true;
      this.List = [];
      axios
        .get(calculate.getAll + "?search=" + this.search + "&page=" + this.currentPage, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
    getCalculatorList(){
      const calculatorList = this.List.map((item,index) => {
        return {
             ...item,
            index:index+1,
            name: item.name,
            startAndFinish:item.startPosition + " -- " + item.finishPosition,
            tOneWay: item.oneWayKm +' Km'
        };
      }); 
      return calculatorList;
    },
    editItem(item) {
      this.$modal.show("editCalculateroute-modal");
      this.selectedItem = item;
      this.$refs.editCalculateroute.show();
    },
    deleteItem(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Planı silmek istediğinize emin misiniz ?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          axios
            .post(
              calculate.delete,
              {
                rowId: item.id,
                name: item.name,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.userData.token,
                },
              }
            )
            .then((res) => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
              this.getAll();
            })
            .catch((err) => {
              this.swalBox(
                "error",
                "HATA",
                err.response.data.message,
                false,
                this.$t("general.OkayTitle")
              );
            });
        }
      });
    },
  },
  created() {
    this.getAll();
  },
  watch: {
    currentPage() {
      this.getAll();
    },
  },
};
</script>
